package fyi.moko.hotpl.domain.usecase

import fyi.moko.hotpl.domain.model.PlaceVisitSummary
import fyi.moko.hotpl.domain.repository.PlaceRepository
import kotlinx.coroutines.flow.Flow

class ObserveVisitSummariesUseCase(
    private val repository: PlaceRepository,
) {
    operator fun invoke(): Flow<List<PlaceVisitSummary>> = repository.observeVisitSummaries()
}